import classNames from 'classnames'
import { useState } from 'react'

import { type ICommonField } from '@/app/types/common'
import { type IGuideMarker } from '@/app/types/dmsTypes'

import Arrow from './arrow.svg'
import style from './SelectColored.module.scss'

interface IProps {
    entity: ICommonField
    onAddMarker: (color: string) => void
    onRemoveMarker: (color: string) => void
    onSetIsTouched: () => void
    className?: string
    disabled?: boolean
    options: IGuideMarker[]
}

export const SelectColored = (props: IProps) => {
    const { options, entity, className, onAddMarker, onRemoveMarker } = props
    const { name, value, error, isTouched } = entity
    const [showOpts, setShowOpts] = useState<boolean>(false)
    const isError = isTouched && !!error

    const chosenValuesList = value ? value.split(',') : []

    const actualOptions = options.filter((opt) => !chosenValuesList.includes(opt.code))

    return (
        <div className={classNames(style.container, className && className)}>
            <div className={style.blockTitle}>
                <span>{name}</span>
            </div>
            <div className={style.inputWrapper}>
                <div className={classNames(style.field, isError && style.fieldError)}>
                    {chosenValuesList.map((color, idx) => (
                        <div
                            key={idx}
                            className={style.chosenOption}
                            style={{ background: `${color}` }}
                            onClick={() => onRemoveMarker(color)}
                        />
                    ))}
                </div>
                <div className={style.trigger} onClick={() => setShowOpts((prev) => !prev)}>
                    <Arrow />
                </div>
                {showOpts && actualOptions.length > 0 && (
                    <div className={style.options}>
                        {actualOptions.map((option, idx) => {
                            const { code } = option
                            return (
                                <div
                                    key={idx}
                                    className={style.option}
                                    style={{ background: `${code}` }}
                                    onClick={() => onAddMarker(code)}
                                />
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}
